<template lang="pug">
  div.bar
    button.tl(@mousedown="mousedown",@touchstart="mousedown",:style="sty()")
      img(src="@/assets/ico_tgl_lr.svg")
</template>

<script>
export default {
  name: 'Position',
  data () {
    return {
      alert: false,
      left: 0,
      width: 844,
      height: 528
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    update () {
      if (this.set !== undefined) {
        this.set = this.sets[this.number];
        this.left = this.c2p(this.set.left);
      }
    },
    sty () {
      return {
        left: this.left + 'px'
      };
    },
    mousedown (e) {
      this.posSX = e.currentTarget.offsetLeft || 0;
      this.startX = this.mp(e).clientX;
      this.flg = true;
      window.addEventListener('mousemove', this.mousemove);
      window.addEventListener('mouseup', this.mouseup, false);
      window.addEventListener('touchmove', this.mousemove);
      window.addEventListener('touchend', this.mouseup, false);
      this.prev = this.width;
    },
    mousemove (e) {
      if (this.flg) {
        let po = (this.mp(e).clientX - this.startX) + this.posSX;
        if (po < 0) {
          po = 0;
        } else if (po > 500) {
          po = 500;
        }
        this.left = Math.round(po);
        this.$set(this.sets[this.number], 'left', Math.round(this.p2c(po)));
        this.sets.splice(this.number, 1, this.sets[this.number]);
      }
    },
    mouseup () {
      window.removeEventListener('mousemove', this.mousemove);
      window.removeEventListener('mouseup', this.mouseup);
      window.removeEventListener('touchmove', this.mousemove);
      window.removeEventListener('touchend', this.mouseup);
    }
  },
  created () {
    this.update();
  }
};
</script>
<style lang="stylus" scoped>
  .bar
    position absolute
    left 100px
    top 30px
    width 0
    height 0
    .tl
      position absolute
      left 0
      top 0
      transform translate(-50%,-50%)
      .preview &
        display none
      img
        user-select none
        pointer-events none
</style>



// WEBPACK FOOTER //
// src/components/front/Position.vue